/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClassificationResult } from './classificationResult';
import { ClassificationRule } from './classificationRule';

export interface ProjectFile { 
    id?: string;
    name?: string;
    isFolder?: boolean;
    size?: number;
    lastModified?: Date;
    lastModifiedBy?: string;
    created?: Date;
    createdBy?: string;
    contentType?: string;
    fileType?: ProjectFile.FileTypeEnum;
    link?: string;
    fragmentsLink?: string;
    fragmentsCreated?: boolean;
    classificationResults?: Array<ClassificationResult>;
    classificationRules?: Array<ClassificationRule>;
    children?: Array<ProjectFile>;
    linkedFiles?: Array<ProjectFile>;
    description?: string;
    fileStatus?: ProjectFile.FileStatusEnum;
    errorReason?: string;
    sourceLinkId?: string;
    externalWebUrl?: string;
    classificationAttempts?: number;
    modelTag?: string;
    sizeInMB?: number;
    analyseCompleted?: boolean;
    analyseFailed?: boolean;
    classificationExhausted?: boolean;
    readonly parentId?: string;
    readonly documentClassTitles?: Array<string>;
}
export namespace ProjectFile {
    export type FileTypeEnum = 'FOLDER' | 'PDF' | 'IFC' | 'EXCEL' | 'POWERPOINT' | 'WORD' | 'UNKNOWN' | 'COORDINATION';
    export const FileTypeEnum = {
        FOLDER: 'FOLDER' as FileTypeEnum,
        PDF: 'PDF' as FileTypeEnum,
        IFC: 'IFC' as FileTypeEnum,
        EXCEL: 'EXCEL' as FileTypeEnum,
        POWERPOINT: 'POWERPOINT' as FileTypeEnum,
        WORD: 'WORD' as FileTypeEnum,
        UNKNOWN: 'UNKNOWN' as FileTypeEnum,
        COORDINATION: 'COORDINATION' as FileTypeEnum
    };
    export type FileStatusEnum = 'UPLOADING' | 'UPLOADED' | 'PROCESSING' | 'READY' | 'CHECKED' | 'ERROR';
    export const FileStatusEnum = {
        UPLOADING: 'UPLOADING' as FileStatusEnum,
        UPLOADED: 'UPLOADED' as FileStatusEnum,
        PROCESSING: 'PROCESSING' as FileStatusEnum,
        READY: 'READY' as FileStatusEnum,
        CHECKED: 'CHECKED' as FileStatusEnum,
        ERROR: 'ERROR' as FileStatusEnum
    };
}